import * as React from 'react';
import { Cascader as DesignCascader } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const Cascader = ({ element, elementStyle }) => {
  const { formItemSettings, formSettings, settings, className } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <DesignCascader style={{ width: '100%' }} {...formItemSettings} className={className} />
    </FormItem>
  );
};

export default Cascader;
